import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AdminLayout } from '../../components/admin/AdminLayout';
import { 
  FileText, 
  ChevronRight,
  Globe,
  Edit2,
  ExternalLink,
  LayoutDashboard,
  MapPin,
  Trophy,
  Users,
  Flag,
  Utensils,
  Image
} from 'lucide-react';

const pageItems = [
  { key: 'home', label: 'Inici', icon: LayoutDashboard, path: '/' },
  { key: 'el-camp', label: 'El Camp', icon: MapPin, path: '/el-camp' },
  { key: 'jugar', label: 'Jugar', icon: Globe, path: '/jugar' },
  { key: 'competicio', label: 'Competició', icon: Trophy, path: '/competicio' },
  { key: 'iniciacio', label: 'Acadèmia', icon: Users, path: '/iniciacio' },
  { key: 'driving-range', label: 'Pràctiques', icon: Flag, path: '/driving-range' },
  { key: 'restaurant', label: 'Restaurant', icon: Utensils, path: '/restaurant' },
  { key: 'allotjament', label: 'Allotjament', icon: Image, path: '/allotjament' },
  { key: 'correspondencies', label: 'Correspondències', icon: Globe, path: '/correspondencies' },
  { key: 'contacte', label: 'Contacte', icon: MapPin, path: '/contacte' },
  { key: 'equip', label: "L'Equip", icon: Users, path: '/equip' },
];

const languages = [
  { code: 'ca', name: 'Català', flag: '🇦🇩' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

export const AdminPages = () => {
  const { isAdmin } = useAuth();

  return (
    <AdminLayout>
      <div className="space-y-6" data-testid="admin-pages">
        {/* Header */}
        <div>
          <h1 className="text-2xl font-display font-semibold text-[#1A4D2E]">
            Gestió de Pàgines
          </h1>
          <p className="text-[#666666] mt-1">
            Edita el contingut de cada pàgina en tots els idiomes
          </p>
        </div>

        {/* Info banner */}
        {!isAdmin && (
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-sm text-amber-800">
              <strong>Nota:</strong> Com a Editor, pots modificar textos, imatges internes i enllaços. 
              No pots modificar heroes, logos ni estructura.
            </p>
          </div>
        )}

        {/* Pages grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {pageItems.map((page) => (
            <div
              key={page.key}
              className="bg-white border border-[#E5E5E5] rounded-lg overflow-hidden hover:border-[#1A4D2E] hover:shadow-sm transition-all"
              data-testid={`page-card-${page.key}`}
            >
              <div className="p-5">
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#1A4D2E]/10 rounded-lg flex items-center justify-center">
                      <page.icon className="w-5 h-5 text-[#1A4D2E]" />
                    </div>
                    <div>
                      <h3 className="font-medium text-[#333333]">{page.label}</h3>
                      <p className="text-xs text-[#888888]">{page.path}</p>
                    </div>
                  </div>
                  <a
                    href={page.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#888888] hover:text-[#1A4D2E]"
                    title="Veure pàgina"
                  >
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
              </div>

              {/* Language edit buttons */}
              <div className="border-t border-[#E5E5E5] bg-[#F9F9F7] px-5 py-3">
                <p className="text-xs text-[#888888] mb-2">Editar per idioma:</p>
                <div className="flex gap-2">
                  {languages.map((lang) => (
                    <Link
                      key={lang.code}
                      to={`/admin/pages/${page.key}/${lang.code}`}
                      className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-[#E5E5E5] rounded text-sm hover:border-[#1A4D2E] hover:text-[#1A4D2E] transition-colors"
                      title={`Editar en ${lang.name}`}
                    >
                      <span>{lang.flag}</span>
                      <span className="uppercase text-xs font-medium">{lang.code}</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminPages;
